<template>
    <div class="competences-wrapper">
        <h3 class="title">Необходимо прокачать</h3>
        <StyleTabs
            :tabs="tabs"
            :activeTab="activeTab"
            class="tabs"
            @change="setTab"
        />
        <div class="tab">
            <component
                :is="tabs[activeTab].component"
            />
        </div>
    </div>
</template>

<script>
import StyleTabs from "../StyleTabs";
import HardCompetencesWrapper from "./componentsMobile/hard-competences/HardCompetencesWrapper";
import SoftCompetencesWrapper from "./componentsMobile/soft-competences/SoftCompetencesWrapper";

export default {
    name: "CompetencesMobile",

    components: {
        StyleTabs,
        HardCompetencesWrapper,
        SoftCompetencesWrapper,
    },

    data() {
        return {
            activeTab: 0,
            tabs: [
                {
                    title: 'Компетенции',
                    component: 'SoftCompetencesWrapper',
                },
                {
                    title: 'Проф. навыки',
                    component: 'HardCompetencesWrapper',
                },
            ],
        };
    },

    methods: {
        setTab(index){
            this.activeTab = index;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "~@/styles/rem";

    .competences-wrapper{
        padding: 24px;
        background: white;
        border: 1px solid #D2D5D9;
        width: 100%;
        min-height: 80vh;

        @include on-xs {
            padding: 16px;
            border: none;
            box-shadow: 0 2px 8px rgba(155, 161, 166, 0.23626);
        }


        .title {
            margin: 0 0 16px 0;
            font-weight: 600;
            font-size: 24px;
            line-height: 32px;
            color: #2A2626;

            @include on-xs {
                display: none;
            }
        }
        .tabs {
            width: 100%;
            margin: 0 0 32px 0;

            @include on-xs {
                margin: 0 0 24px 0;
                //display: none;
            }
        }
    }
</style>